import React from "react";
import { australianStates } from "../../helpers/form";
import Country from "../../enums/Country";
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";

export default ({
  className,
  countryCode,
  value,
  errors = [],
  onChange,
  name,
  disabled
}) => {
  if (countryCode === Country.Australia) {
    return (
      <div className={className}>
        <FormControl variant="standard" fullWidth>
          <InputLabel error={errors.length > 0}>State</InputLabel>
          <Select
            name={name}
            error={errors.length > 0}
            className={errors.length > 0 ? "form-error" : ""}
            onChange={onChange}
            options={australianStates}
            value={value}
            disabled={disabled}
          >
            {!australianStates.length
              ? null
              : australianStates.map((state) => {
                  return (
                    <MenuItem key={state.value} value={state.value}>
                      {state.label}
                    </MenuItem>
                  );
                })}
          </Select>
          {errors.length > 0 ? (
            <FormHelperText htmlFor="contact-relationship-select" error>
              {errors[0]}
            </FormHelperText>
          ) : (
            false
          )}
        </FormControl>
      </div>
    );
  }

  return (
    <div className={className}>
      <TextField
        error={errors && errors.length > 0}
        helperText={errors[0]}
        label="State / Region / Province"
        fullWidth={true}
        name={name}
        onChange={onChange}
        value={value}
        variant="standard"
        disabled={disabled}
      />
    </div>
  );
};
